import { detectRuntime } from '../runtime/detectRuntime';
import { getVkLaunchParamsFromLocation } from '../vk/launchParams';

/** Comma-separated VK user ids allowed to use admin client tools. */
function parseAdminVkUserIds(raw: string | undefined): Set<string> {
  if (raw == null || raw.trim() === '') {
    return new Set();
  }
  return new Set(
    raw
      .split(',')
      .map((id) => id.trim())
      .filter((id) => id !== ''),
  );
}

/**
 * Client-side admin UI gate (not server auth).
 * True in local development browser, or when vk_user_id is in REACT_APP_ADMIN_VK_USER_IDS.
 */
export function isAdminClient(): boolean {
  if (detectRuntime().kind === 'standalone_browser' && process.env.NODE_ENV === 'development') {
    return true;
  }

  const allowlist = parseAdminVkUserIds(process.env.REACT_APP_ADMIN_VK_USER_IDS);
  if (allowlist.size === 0) {
    return false;
  }

  const vkUserId = getVkLaunchParamsFromLocation().get('vk_user_id');
  if (vkUserId == null || vkUserId === '') {
    return false;
  }

  return allowlist.has(vkUserId);
}
